// extracted by mini-css-extract-plugin
module.exports = {"w126hx4k":"w126hx4k"};